"use client";

import { useEffect, useMemo, useState, useCallback } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { useFuncion } from "../../context/FuncionContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useAuth } from "../../context/AuthContext";

const DETAIL_CSS = `
.ud-shell{
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 22px 16px 40px;
  min-height: 100vh;
}

@media (max-width: 640px){
  .ud-shell{ padding: 16px 10px 28px; }
}

.ud-back{
  text-decoration:none;
  color:#6b7280;
  font-size: 0.9rem;
  font-weight:800;
  display:inline-flex;
  gap:8px;
  align-items:center;
  margin-bottom: 14px;
}
.ud-back span:first-child{ font-size:1rem; }

.ud-header{
  background:#ffffff;
  border-radius: 22px;
  border:1px solid rgba(15,23,42,0.06);
  box-shadow: 0 12px 36px rgba(15,23,42,0.14);
  padding: 18px 18px 16px;
  margin-bottom: 14px;
}

.ud-header-top{
  display:grid;
  grid-template-columns: minmax(0,2.2fr) minmax(0,1.1fr);
  gap:14px;
  align-items:flex-start;
}

@media (max-width: 900px){
  .ud-header-top{ grid-template-columns: minmax(0,1fr); }
}

.ud-identity{
  display:flex;
  gap:12px;
  align-items:flex-start;
}

.ud-avatarWrap{
  display:flex;
  flex-direction:column;
  align-items:center;
  gap:6px;
  flex:0 0 auto;
}

.ud-avatar{
  width:54px;
  height:54px;
  border-radius:999px;
  background:conic-gradient(from 160deg,#2563eb,#4f46e5,#22c55e,#2563eb);
  display:flex;
  align-items:center;
  justify-content:center;
  color:#f9fafb;
  font-weight:900;
  font-size:1.05rem;
  box-shadow:0 10px 26px rgba(37,99,235,0.45);
}

.ud-avatar-tag{
  padding:3px 8px;
  border-radius:999px;
  font-size:0.72rem;
  font-weight:900;
  background:#eff6ff;
  color:#1d4ed8;
  text-align:center;
  white-space:nowrap;
}

.ud-identity-main{ flex:1; min-width:0; }

.ud-title{
  margin:0;
  font-size: 1.45rem;
  font-weight: 950;
  color:#0f172a;
  letter-spacing:-.01em;
}

.ud-sub{
  margin-top:4px;
  color:#4b5563;
  font-weight:700;
  font-size:0.95rem;
  display:flex;
  flex-wrap:wrap;
  gap:6px;
  align-items:center;
}
.ud-sub .dot{ color:#cbd5f5; margin:0 2px; }

.ud-chips{
  margin-top:10px;
  display:flex;
  flex-wrap:wrap;
  gap:6px;
}

.ud-roleChip{
  padding: 4px 10px;
  border-radius:999px;
  font-size: 0.75rem;
  font-weight:900;
  background:#eef2ff;
  border:1px solid #c7d2fe;
  color:#3730a3;
  text-transform:capitalize;
}

.ud-statusChip{
  padding: 4px 10px;
  border-radius:999px;
  font-size: 0.75rem;
  font-weight:950;
  border:1px solid transparent;
}
.ud-statusChip--on{
  background:#e8f5e9;
  border-color:#4CAF50;
  color:#1b5e20;
}
.ud-statusChip--off{
  background:#ffebee;
  border-color:#f44336;
  color:#b71c1c;
}

.ud-header-actions{
  display:flex;
  flex-direction:column;
  gap:8px;
  align-items:flex-end;
  justify-content:space-between;
}

@media (max-width: 900px){
  .ud-header-actions{ align-items:flex-start; }
}

.ud-toggleBtn{
  border:none;
  border-radius: 999px;
  padding: 10px 14px;
  font-weight:950;
  font-size:0.92rem;
  cursor:pointer;
  color:#fff;
  background:linear-gradient(135deg,#4CAF50,#2E7D32);
  display:inline-flex;
  align-items:center;
  gap:8px;
}

.ud-toggleBtn--danger{
  background:linear-gradient(135deg,#f44336,#d32f2f);
}

.ud-toggleHint{
  font-size:0.78rem;
  color:#94a3b8;
  font-weight:650;
  max-width: 420px;
  line-height:1.25;
}

.ud-header-meta{
  margin-top: 12px;
  padding-top: 12px;
  border-top:1px dashed #e5e7eb;
  display:flex;
  gap:10px;
  flex-wrap:wrap;
  font-size:0.82rem;
  color:#6b7280;
  font-weight:650;
}

.ud-header-details{
  margin-top:10px;
  display:grid;
  grid-template-columns: repeat(3,minmax(0,1fr));
  gap:10px;
}
@media (max-width: 900px){
  .ud-header-details{ grid-template-columns: repeat(2,minmax(0,1fr)); }
}
@media (max-width: 600px){
  .ud-header-details{ grid-template-columns: minmax(0,1fr); }
}

.ud-detailCard{
  border-radius:14px;
  border:1px solid #e5e7eb;
  padding:10px 12px;
  background:#f9fafb;
}
.ud-detail-label{
  display:block;
  font-size:0.72rem;
  font-weight:800;
  text-transform:uppercase;
  letter-spacing:0.04em;
  color:#9ca3af;
  margin-bottom:3px;
}
.ud-detail-value{
  font-size:0.92rem;
  font-weight:800;
  color:#0f172a;
  word-break:break-word;
}

.ud-alert{
  margin-top:10px;
  background:#fff3cd;
  border:1px solid #ffecb5;
  border-radius: 14px;
  padding: 10px 12px;
  color:#856404;
  font-weight:750;
  font-size:0.86rem;
}

.ud-note{
  margin-top:10px;
  background:#f8fafc;
  border:1px solid #e2e8f0;
  border-radius: 14px;
  padding: 10px 12px;
  color:#475569;
  font-weight:650;
  font-size:0.85rem;
  line-height:1.3;
}
.ud-note strong{ color:#0f172a; }

.ud-tabs{
  display:flex;
  gap:8px;
  flex-wrap:wrap;
  margin: 10px 0 14px;
}

.ud-tab{
  border-radius:999px;
  padding: 10px 13px;
  font-size:0.92rem;
  font-weight:950;
  border:2px solid #e5e7eb;
  background:#ffffff;
  cursor:pointer;
  display:inline-flex;
  align-items:center;
  gap:8px;
}

.ud-tab span.emoji{ font-size:1rem; }

.ud-tab--active-est{
  border-color:#16a34a;
  background:#dcfce7;
  color:#166534;
}
.ud-tab--active-doc{
  border-color:#7e22ce;
  background:#f3e8ff;
  color:#6b21a8;
}

.ud-panel{
  background:#ffffff;
  border-radius: 18px;
  border:1px solid #e5e7eb;
  box-shadow:0 8px 24px rgba(15,23,42,0.06);
  padding: 16px 16px 18px;
}

.ud-panel-header{
  display:flex;
  justify-content:space-between;
  align-items:flex-start;
  flex-wrap:wrap;
  gap:10px;
  margin-bottom: 12px;
}

.ud-panel-title{
  margin:0;
  font-size:1.05rem;
  font-weight:950;
  color:#0f172a;
}
.ud-panel-sub{
  font-size:0.82rem;
  color:#6b7280;
  font-weight:650;
  line-height:1.25;
}

.ud-formRow{
  display:flex;
  flex-wrap:wrap;
  gap:10px;
  margin-top:8px;
  margin-bottom:10px;
}

.ud-select{
  padding:10px 10px;
  border-radius:12px;
  border:2px solid #e5e7eb;
  min-width:260px;
  font-size:0.92rem;
  font-weight:650;
  background:#ffffff;
}
@media (max-width: 520px){
  .ud-select{ min-width: 100%; width:100%; }
}

.ud-submitBtn{
  border:none;
  border-radius:12px;
  padding:10px 14px;
  font-weight:950;
  font-size:0.92rem;
  cursor:pointer;
  color:#ffffff;
  display:inline-flex;
  align-items:center;
  gap:8px;
}

.ud-list{
  margin-top: 10px;
  display:grid;
  gap:8px;
}

.ud-empty{
  padding: 14px 12px;
  background:#f9fafb;
  border-radius:14px;
  border:1px dashed #cbd5e1;
  font-size:0.92rem;
  font-weight:750;
  color:#64748b;
}

.ud-item{
  border-radius:14px;
  border:1px solid #e5e7eb;
  padding: 12px 12px;
  display:flex;
  justify-content:space-between;
  gap:10px;
  flex-wrap:wrap;
}

.ud-item-main{
  display:flex;
  flex-direction:column;
  gap:3px;
  min-width: 0;
}

.ud-item-title{
  font-weight:950;
  font-size:0.98rem;
  color:#0f172a;
}

.ud-item-sub{
  font-size:0.82rem;
  color:#6b7280;
  font-weight:650;
}

.ud-item-chips{
  margin-top:6px;
  display:flex;
  flex-wrap:wrap;
  gap:6px;
}

.ud-chip{
  padding:4px 9px;
  border-radius:999px;
  font-size:0.75rem;
  font-weight:950;
  border:1px solid transparent;
}

.ud-chip--info{
  background:#e3f2fd;
  border-color:#90caf9;
  color:#0d47a1;
}
.ud-chip--note{
  background:#eceff1;
  border-color:#cfd8dc;
  color:#455a64;
}
.ud-chip--on{
  background:#e8f5e9;
  border-color:#4CAF50;
  color:#1b5e20;
}
.ud-chip--off{
  background:#ffebee;
  border-color:#f44336;
  color:#b71c1c;
}

.ud-removeBtn{
  border:none;
  border-radius: 999px;
  padding: 8px 10px;
  font-weight:950;
  font-size:0.85rem;
  cursor:pointer;
  color:#ffffff;
  background:linear-gradient(135deg,#f44336,#d32f2f);
  height:38px;
  align-self:center;
}

.ud-item-actions{
  display:flex;
  align-items:center;
  gap:8px;
  flex-wrap:wrap;
}

.ud-actionBtn{
  border:none;
  border-radius:999px;
  padding:8px 12px;
  font-size:0.82rem;
  font-weight:950;
  cursor:pointer;
  display:inline-flex;
  align-items:center;
  gap:8px;
  box-shadow:0 4px 10px rgba(15,23,42,0.10);
  transition: transform 0.12s ease-out, box-shadow 0.12s ease-out, opacity 0.12s ease-out;
}

.ud-actionBtn:active{
  transform:translateY(1px) scale(0.99);
  box-shadow:0 2px 6px rgba(15,23,42,0.16);
}

.ud-actionBtn--toggle-on{
  background:linear-gradient(135deg,#f97316,#ea580c);
  color:#fff;
}
.ud-actionBtn--toggle-off{
  background:linear-gradient(135deg,#22c55e,#16a34a);
  color:#fff;
}
.ud-actionBtn--danger{
  background:linear-gradient(135deg,#f44336,#d32f2f);
  color:#fff;
}
.ud-actionBtn--loading{
  opacity:0.7;
  cursor:wait;
}

/* ✅ Admin compacto (lateral) */
.ud-adminPill{
  display:inline-flex;
  align-items:center;
  gap:10px;
  padding:8px 10px;
  border-radius:999px;
  border:1px solid #e5e7eb;
  background:#ffffff;
  box-shadow:0 6px 16px rgba(15,23,42,.08);
  white-space:nowrap;
}

.ud-adminDot{
  width:10px;
  height:10px;
  border-radius:999px;
  box-shadow: 0 0 0 4px rgba(0,0,0,0.04);
}

.ud-adminLabel{
  font-size:0.82rem;
  font-weight:950;
  letter-spacing:.01em;
  color:#0f172a;
}

.ud-adminBtn{
  border:none;
  border-radius:999px;
  padding:7px 10px;
  font-size:0.8rem;
  font-weight:950;
  cursor:pointer;
  color:#fff;
  display:inline-flex;
  align-items:center;
  gap:6px;
  transition: transform .12s ease, opacity .12s ease;
}
.ud-adminBtn:active{ transform: translateY(1px) scale(.99); }
.ud-adminBtn[disabled]{ opacity:.75; cursor:wait; }

/* Estados */
.ud-adminPill--on{
  border-color:#bbf7d0;
  background:#f0fdf4;
}
.ud-adminPill--off{
  border-color:#fecaca;
  background:#fef2f2;
}

.ud-adminDot--on{ background:#16a34a; }
.ud-adminDot--off{ background:#ef4444; }

.ud-adminBtn--on{ background:linear-gradient(135deg,#16a34a,#15803d); }
.ud-adminBtn--off{ background:linear-gradient(135deg,#ef4444,#b91c1c); }

/* En mobile, que no rompa layout */
@media (max-width: 520px){
  .ud-adminPill{
    width:100%;
    justify-content:space-between;
  }
}

`;

// Helper robusto para obtener el ID real de la asignación
const getAssignmentId = (a) =>
    a?.asignacion_id ||
    a?.assignment_id ||
    a?.relacion_id ||
    a?.rel_id ||
    a?.id ||
    null;

const AdminUsuarioDetalle = () => {
    const { userId } = useParams();
    const location = useLocation();
    const passedUser = location.state?.user || null;
    const { user: authUser } = useAuth();

    const isGlobalAdminViewer = useMemo(() => {
        const rolesArr = Array.isArray(authUser?.roles) ? authUser.roles : [];
        const roles = rolesArr.map(r => String(r?.nombre ?? r?.rol ?? r?.role ?? r).toLowerCase().trim());
        return roles.includes("administrador") || roles.includes("admin") || roles.includes("superadmin");
    }, [authUser]);

    const isDocente = useMemo(() => {
        const rolesArr = Array.isArray(authUser?.roles) ? authUser.roles : [];
        const roles = rolesArr.map(r => String(r?.nombre ?? r?.rol ?? r).toLowerCase().trim());
        return roles.includes('docente') && !isGlobalAdminViewer;
    }, [authUser, isGlobalAdminViewer]);

    const authUserFacultadId = useMemo(() => {
        return authUser?.facultad_id || authUser?.facultades?.[0]?.id || null;
    }, [authUser]);

    const {
        fetchUsers,
        addUserRole,
        removeUserRole,
        updateUser,
        fetchFacultades,
        toggleUserStatus,

        // estudiantes
        fetchStudents,
        enrollStudentToCourse,
        removeStudentFromCourse,
        getStudentCourses,

        // docentes / asistentes
        assignTeacherToCourse,
        updateTeacherAssignment,
        removeTeacherFromCourse,
        getTeacherCourses,

        // ✅ facultad admins
        addFacultyAdmin,
        removeFacultyAdmin,

        // cursos
        fetchCourses,
    } = useFuncion();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [user, setUser] = useState(passedUser);
    const [allCourses, setAllCourses] = useState([]);

    // Tabs
    const [tab, setTab] = useState("estudiante"); // estudiante | docente

    // admin toggle
    const [adminSubmitting, setAdminSubmitting] = useState(false);

    // estudiante
    const [inscripciones, setInscripciones] = useState([]);
    const [studentLoading, setStudentLoading] = useState(false);
    const [enrollForm, setEnrollForm] = useState({ curso_id: "" });
    const [enrollSubmitting, setEnrollSubmitting] = useState(false);

    // docente/asistente
    const [asignaciones, setAsignaciones] = useState([]);
    const [teacherLoading, setTeacherLoading] = useState(false);
    const [assignForm, setAssignForm] = useState({ curso_id: "", rol: "docente" });
    const [assignSubmitting, setAssignSubmitting] = useState(false);
    const [togglingAssignmentId, setTogglingAssignmentId] = useState(null);

    const uid = useMemo(() => parseInt(userId, 10), [userId]);

    const hasRole = useCallback(
        (r) => (user?.roles || []).includes(r),
        [user]
    );

    const userInitials = useMemo(() => {
        const full = `${user?.nombres || ""} ${user?.apellidos || ""}`.trim();
        if (!full) return "U";
        const parts = full.split(/\s+/).slice(0, 2);
        return parts.map((p) => p[0]?.toUpperCase() || "").join("") || "U";
    }, [user]);

    const accountType = useMemo(() => {
        const roles = new Set(user?.roles || []);
        const labels = [];
        if (roles.has("administrador")) labels.push("Administrador");
        if (roles.has("docente")) labels.push("Docente");
        if (roles.has("asistente")) labels.push("Asistente");
        if (roles.has("estudiante")) labels.push("Estudiante");
        if (labels.length === 0) return "Usuario";
        return labels.join(" / ");
    }, [user]);

    const [allFacultades, setAllFacultades] = useState([]);

    // --- ESTADO MODAL EDITAR USUARIO ---
    const [showEditModal, setShowEditModal] = useState(false);
    const [editForm, setEditForm] = useState({
        nombres: '', apellidos: '', email: '', codigo_institucional: '',
        fecha_nacimiento: '', ocupacion: '',
        celular_contacto: '', ciudad_residencia: ''
    });
    const [editSubmitting, setEditSubmitting] = useState(false);
    const [editError, setEditError] = useState(null);

    // Abrir modal con datos actuales del usuario
    const handleOpenEdit = () => {
        setEditForm({
            nombres: user?.nombres || '',
            apellidos: user?.apellidos || '',
            email: user?.email || user?.correo || '',   // ← orden: email primero
            codigo_institucional: user?.codigo_institucional || '',
            fecha_nacimiento: user?.fecha_nacimiento || '',
            ocupacion: user?.ocupacion || '',
            celular_contacto: user?.celular_contacto || '',
            ciudad_residencia: user?.ciudad_residencia || '',
        });
        setEditError(null);
        setShowEditModal(true);
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setEditSubmitting(true);
        setEditError(null);
        try {
            await updateUser(Number(uid), {
                nombres: editForm.nombres,
                apellidos: editForm.apellidos,
                email: editForm.email, // ✅ Volvemos a poner 'email', que es lo que exige tu admin.js
                codigo_institucional: editForm.codigo_institucional,

                // El secreto para que guarde en la BD es asegurar que los campos vacíos sean null:
                fecha_nacimiento: editForm.fecha_nacimiento || null,
                ocupacion: editForm.ocupacion || null,
                celular_contacto: editForm.celular_contacto || null,
                ciudad_residencia: editForm.ciudad_residencia || null,
            });

            // Recargar usuario fresco desde el servidor
            const data = await fetchUsers({ page: 1, limit: 1000 });
            const arr = Array.isArray(data) ? data : data.users || [];
            const fresh = arr.find(x => Number(x.id) === uid);
            if (fresh) setUser(fresh);
            // Reemplaza todo desde "// Recargar usuario fresco" hasta antes del "setShowEditModal(false)"
            setUser(prev => ({
                ...prev,
                nombres: editForm.nombres,
                apellidos: editForm.apellidos,
                correo: editForm.email,
                email: editForm.email,
                codigo_institucional: editForm.codigo_institucional,
                fecha_nacimiento: editForm.fecha_nacimiento || null,
                ocupacion: editForm.ocupacion || null,
                celular_contacto: editForm.celular_contacto || null,
                ciudad_residencia: editForm.ciudad_residencia || null,
            }));

            setShowEditModal(false);

            setShowEditModal(false);
        } catch (err) {
            console.error('ERROR COMPLETO updateUser:', err);
            const msg = err?.response?.data?.message
                || err?.response?.data?.error
                || err?.response?.data?.details
                || err?.message
                || 'Error al guardar cambios';
            setEditError(msg);
        } finally {
            setEditSubmitting(false);
        }
    };

    // Estados para el formulario de inscripción nuevo
    const [selectedRolCurso, setSelectedRolCurso] = useState('estudiante');
    const [selectedFacAsignar, setSelectedFacAsignar] = useState('');
    const [searchCursoAsignar, setSearchCursoAsignar] = useState('');
    const [selectedFacAdmin, setSelectedFacAdmin] = useState('');
    // Estado para filtros y vista de tabla
    const [cursoViewMode, setCursoViewMode] = useState('table');
    const [cursoRolFilter, setCursoRolFilter] = useState('Todos');
    const [searchCursoAsignado, setSearchCursoAsignado] = useState('');
    const [cursosPageSize, setCursosPageSize] = useState(10);
    const [cursoSortConfig, setCursoSortConfig] = useState({ key: 'curso_nombre', direction: 'asc' });

    const handleSortCurso = (key) => {
        setCursoSortConfig(prev => ({
            key,
            direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
        }));
    };

    const getCursoSortIcon = (key) => {
        if (cursoSortConfig.key !== key) return ' ↕';
        return cursoSortConfig.direction === 'asc' ? ' ↑' : ' ↓';
    };

    const ensureRole = useCallback(
        async (role) => {
            if (!user) return false;
            if (hasRole(role)) return true;

            await addUserRole(user.id, role);

            setUser((p) => ({
                ...p,
                roles: Array.from(new Set([...(p?.roles || []), role])),
            }));

            return true;
        },
        [addUserRole, hasRole, user]
    );

    // ✅ mini toggle admin (sin pestaña roles)
    const toggleAdminRole = useCallback(async () => {
        if (!user) return;

        const isAdmin = hasRole("administrador");
        const msg = isAdmin
            ? "¿Quitar rol Administrador a este usuario?"
            : "¿Asignar rol Administrador a este usuario?";

        if (!window.confirm(msg)) return;

        setAdminSubmitting(true);
        setError(null);

        try {
            if (isAdmin) {
                await removeUserRole(user.id, "administrador");
                setUser((p) => ({
                    ...p,
                    roles: (p.roles || []).filter((r) => r !== "administrador"),
                }));
            } else {
                await addUserRole(user.id, "administrador");
                setUser((p) => ({
                    ...p,
                    roles: Array.from(new Set([...(p.roles || []), "administrador"])),
                }));
            }
        } catch (e) {
            console.error(e);
            setError(e.message || "Error actualizando rol administrador");
        } finally {
            setAdminSubmitting(false);
        }
    }, [user, hasRole, addUserRole, removeUserRole]);

    // ---------------------------
    // Cargar usuario + cursos
    // ---------------------------
    const loadUser = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);

            const data = await fetchUsers({ page: 1, limit: 1000 });
            const arr = Array.isArray(data) ? data : data.users || [];
            const found = arr.find((x) => Number(x.id) === uid);
            if (!found) throw new Error("Usuario no encontrado");
            setUser(found);

            const coursesData = await fetchCourses({
                page: 1,
                limit: 1000,
                showAll: true,
            });
            const coursesArray = Array.isArray(coursesData)
                ? coursesData
                : coursesData.courses || [];

            setAllCourses(coursesArray.filter((c) => c.activo));
            try {
                const facData = await fetchFacultades({ page: 1, limit: 200 });
                const facArr = Array.isArray(facData) ? facData : facData.facultades || [];
                setAllFacultades(facArr.filter(f => f.activo !== false));
            } catch (_) { }
        } catch (e) {
            console.error(e);
            setError(e.message);
        } finally {
            setLoading(false);
        }
        if (isDocente && authUserFacultadId) {
            setSelectedFacAsignar(String(authUserFacultadId));
        }
    }, [fetchUsers, fetchCourses, fetchFacultades, uid]);

    useEffect(() => {
        loadUser();
    }, [loadUser]);

    // ---------------------------
    // Cargar data Estudiante
    // ---------------------------
    const loadStudentData = useCallback(async () => {
        if (!uid) return;
        setStudentLoading(true);

        try {
            try {
                await getStudentCourses(uid);
            } catch (_) { }

            const resp = await fetchStudents({
                page: 1,
                limit: 2000,
                include_enrollments: true,
            });

            const arr = Array.isArray(resp) ? resp : resp.students || [];
            const fresh =
                arr.find((s) => Number(s.id) === uid) ||
                arr.find((s) => Number(s.usuario_id) === uid) ||
                null;

            const list =
                fresh?.inscripciones || fresh?.enrollments || fresh?.cursos || [];
            setInscripciones(Array.isArray(list) ? list : []);
        } catch (e) {
            console.error(e);
            setError(e.message);
        } finally {
            setStudentLoading(false);
        }
    }, [uid, getStudentCourses, fetchStudents]);

    // ---------------------------
    // Cargar data Docente/Asistente
    // ---------------------------
    const loadTeacherData = useCallback(async () => {
        if (!uid) return;
        setTeacherLoading(true);

        try {
            // ✅ IMPORTANTE: este endpoint devuelve objeto {teacher, courses, pagination}
            const resp = await getTeacherCourses(uid, { page: 1, limit: 2000 });

            let list;
            if (Array.isArray(resp)) list = resp;
            else if (resp && typeof resp === "object") {
                list =
                    resp.asignaciones ||
                    resp.assignments ||
                    resp.cursos ||
                    resp.courses || // <- aquí cae tu respuesta
                    resp.data ||
                    [];
            } else list = [];

            setAsignaciones(Array.isArray(list) ? list : []);
        } catch (e) {
            console.error(e);
            setError(e.message || "Error cargando asignaciones de docente");
            setAsignaciones([]);
        } finally {
            setTeacherLoading(false);
        }
    }, [uid, getTeacherCourses]);

    useEffect(() => {
        if (!user) return;
        if (tab === "estudiante") loadStudentData();
        if (tab === "docente") loadTeacherData();
    }, [tab, user, loadStudentData, loadTeacherData]);

    // ---------------------------
    // Cursos disponibles
    // ---------------------------
    const availableCoursesForStudent = useMemo(() => {
        const enrolled = inscripciones
            .map((i) => Number(i.curso_id || i.course_id || i.id))
            .filter(Boolean);

        return allCourses.filter((c) => !enrolled.includes(Number(c.id)));
    }, [allCourses, inscripciones]);

    const availableCoursesForTeacher = useMemo(() => {
        const assigned = asignaciones
            .map((a) =>
                Number(
                    a.curso_id ||
                    a.course_id ||
                    a.cursoId ||
                    a.courseId ||
                    a.id_curso ||
                    0
                )
            )
            .filter(Boolean);

        return allCourses.filter((c) => !assigned.includes(Number(c.id)));
    }, [allCourses, asignaciones]);

    // ---------------------------
    // Estado usuario
    // ---------------------------
    const toggleActive = async () => {
        if (!user) return;

        const nextActive = !user.activo;

        try {
            await toggleUserStatus(user.id, nextActive);
            setUser((p) => ({ ...p, activo: nextActive }));
        } catch (e) {
            console.error(e);
            setError(e.message);
        }
    };

    // ---------------------------
    // Estudiante: Inscribir
    // ---------------------------
    const handleEnroll = async (e) => {
        e.preventDefault();
        if (!enrollForm.curso_id) return;

        setEnrollSubmitting(true);
        setError(null);

        try {
            if (!hasRole("estudiante")) await ensureRole("estudiante");

            await enrollStudentToCourse(enrollForm.curso_id, {
                usuario_id: uid,
                curso_id: enrollForm.curso_id,
                estado: "inscrito",
            });

            setEnrollForm({ curso_id: "" });
            await loadStudentData();
        } catch (ex) {
            console.error(ex);
            setError(ex.message);
        } finally {
            setEnrollSubmitting(false);
        }
    };

    // ---------------------------
    // Docente/Asistente: Asignar
    // ---------------------------
    const handleAssign = async (e) => {
        e.preventDefault();
        if (!assignForm.curso_id || !assignForm.rol) return;

        setAssignSubmitting(true);
        setError(null);

        try {
            // ✅ No tocar usuario_roles aquí si tipo_rol no incluye docente/asistente
            // La asignación real se maneja en curso_docentes

            await assignTeacherToCourse(assignForm.curso_id, {
                usuario_id: uid,
                rol: assignForm.rol,              // "docente" | "asistente"
                activo: true,
                tipo_asignacion: assignForm.rol,  // ✅ requerido por tu backend / normalización
            });

            setAssignForm({ curso_id: "", rol: "docente" });
            await loadTeacherData();
        } catch (ex) {
            console.error(ex);
            setError(ex.message);
        } finally {
            setAssignSubmitting(false);
        }
    };

    // ---------------------------
    // Docente/Asistente: Activar/Inactivar asignación
    // ---------------------------
    const handleToggleAssignmentActive = useCallback(
        async (assignment) => {
            const assignmentId = getAssignmentId(assignment);

            if (!assignmentId) {
                setError("No se pudo determinar el ID de la asignación");
                return;
            }

            const nextActive = !assignment.activo;

            setAsignaciones((prev) =>
                prev.map((a) =>
                    getAssignmentId(a) === assignmentId ? { ...a, activo: nextActive } : a
                )
            );

            setTogglingAssignmentId(assignmentId);

            try {
                const resp = await updateTeacherAssignment(assignmentId, {
                    activo: nextActive,
                    // ✅ por si tu backend lo usa para recalcular / validar
                    tipo_asignacion: assignment.rol,
                });

                if (resp && resp.assignment) {
                    const updated = resp.assignment;
                    setAsignaciones((prev) =>
                        prev.map((a) =>
                            getAssignmentId(a) === assignmentId ? { ...a, ...updated } : a
                        )
                    );
                }
            } catch (e) {
                setError(e.message || "Error actualizando la asignación");
                setAsignaciones((prev) =>
                    prev.map((a) =>
                        getAssignmentId(a) === assignmentId
                            ? { ...a, activo: assignment.activo }
                            : a
                    )
                );
            } finally {
                setTogglingAssignmentId(null);
            }
        },
        [updateTeacherAssignment]
    );

    if (loading) return <LoadingSpinner message="Cargando usuario..." />;

    if (error && !user) {
        return (
            <div className="ud-shell">
                <style>{DETAIL_CSS}</style>
                <Link to="/admin/usuarios" className="ud-back">
                    <span>←</span> <span>Volver a usuarios</span>
                </Link>
                <div className="ud-alert">{error}</div>
            </div>
        );
    }

    const isAdmin = hasRole("administrador");

    // Calcular color del avatar basado en iniciales (igual que en la lista)
    const avatarColor = (() => {
        const colors = ['bg-blue-500', 'bg-green-500', 'bg-purple-500', 'bg-orange-500', 'bg-red-500', 'bg-teal-500', 'bg-indigo-500'];
        const code = (user?.codigo_institucional || user?.id || '').toString();
        return colors[parseInt(code.slice(-1) || '0') % colors.length];
    })();

    return (
        <div className="w-full max-w-[1180px] mx-auto px-4 lg:px-8 py-5 min-h-screen font-sans">

            {/* === HEADER / PERFIL === */}
            <div className="flex flex-col gap-4 mb-4">

                {/* Botón volver — solo móvil */}
                <Link
                    to="/admin/usuarios"
                    className="md:hidden w-full p-3.5 hover:bg-gray-100 rounded-2xl text-gray-600 border border-gray-200 bg-white shadow-sm flex items-center justify-center gap-2 font-bold text-sm"
                >
                    ← Regresar a lista de usuarios
                </Link>

                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 relative overflow-hidden">
                    <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-bl from-green-50 to-transparent rounded-bl-full -z-10 opacity-60 pointer-events-none" />

                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 relative z-10">

                        <div className="flex items-start gap-4 md:gap-5 w-full">
                            {/* Botón volver — escritorio */}
                            <Link
                                to="/admin/usuarios"
                                className="hidden md:flex p-2 hover:bg-gray-100 rounded-full text-gray-500 border border-gray-200 bg-white shadow-sm items-center justify-center mt-3 shrink-0"
                                title="Volver a usuarios"
                            >
                                ‹
                            </Link>

                            {/* Avatar */}
                            <div className="flex flex-col items-center gap-2 shrink-0">
                                <div className={`w-16 h-16 md:w-20 md:h-20 rounded-2xl flex items-center justify-center text-white font-bold text-2xl md:text-3xl shadow-md border-4 border-white ${avatarColor}`}>
                                    {userInitials}
                                </div>
                            </div>

                            {/* Nombre, email, chips */}
                            <div className="mt-1 flex-1">
                                <h1 className="text-[20px] md:text-[22px] font-black text-gray-900 tracking-tight uppercase leading-none">
                                    {user?.apellidos?.toUpperCase()}
                                </h1>
                                <div className="text-gray-700 text-base md:text-lg uppercase mt-1.5 font-bold">
                                    {user?.nombres?.toUpperCase()}
                                </div>
                                <div className="text-gray-500 text-xs md:text-sm mt-0.5">
                                    {user?.correo || user?.email}
                                </div>

                                <div className="flex items-center gap-2 mt-3 flex-wrap">
                                    {(user?.roles || []).map((r, idx) => {
                                        const rStr = String(r?.nombre ?? r?.rol ?? r).toLowerCase();
                                        const styles = rStr.includes('admin')
                                            ? 'bg-orange-50 text-orange-600 border-orange-200'
                                            : rStr === 'docente'
                                                ? 'bg-yellow-50 text-yellow-600 border-yellow-200'
                                                : rStr === 'asistente'
                                                    ? 'bg-green-50 text-green-600 border-green-200'
                                                    : 'bg-blue-50 text-blue-600 border-blue-100';
                                        const label = String(r?.nombre ?? r?.rol ?? r);
                                        return (
                                            <span key={idx} className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase border shadow-sm whitespace-nowrap ${styles}`}>
                                                {label}
                                            </span>
                                        );
                                    })}
                                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-[11px] font-bold border shadow-sm ${user?.activo ? 'bg-green-50 text-green-700 border-green-200' : 'bg-red-50 text-red-700 border-red-200'}`}>
                                        {user?.activo ? 'Activo' : 'Inactivo'}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Botones acción — derecha */}
                        <div className="w-full md:w-auto flex flex-col justify-end gap-2 shrink-0">
                            {/* Abre directamente el expediente del usuario en AdminReportes */}
                            <Link
                                to={`/admin/reportes?category=users&mode=expediente&usuario_id=${encodeURIComponent(user?.id || userId)}&source=admin_usuario_detalle`}
                                state={{ reportUser: { id: user?.id || userId, nombre: user?.nombre, email: user?.email } }}
                                className="bg-blue-50 hover:bg-blue-100 border border-blue-200 text-blue-700 text-xs font-bold px-6 py-2.5 md:py-2 rounded-full transition-colors shadow-sm flex items-center justify-center gap-2 w-full"
                            >
                                📄 Ver Reportes
                            </Link>

                            {/* Botón Activar / Desactivar */}
                            <button
                                type="button"
                                onClick={toggleActive}
                                className={`bg-white border text-xs font-bold px-6 py-2.5 md:py-2 rounded-full transition-colors shadow-sm flex items-center justify-center gap-2 w-full ${user?.activo ? 'hover:bg-red-50 border-red-200 text-red-600' : 'hover:bg-green-50 border-green-200 text-green-600'}`}
                            >
                                {user?.activo ? '👤 Desactivar usuario' : '👤 Activar usuario'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* === BLOQUE DATOS DETALLADOS === */}
            <div className="grid grid-cols-2 lg:flex lg:flex-row bg-gray-100 rounded-2xl shadow-sm border border-gray-100 mb-6 overflow-hidden gap-[1px]">
                <div className="bg-white hover:bg-gray-50 flex-1 px-4 py-4 flex flex-col justify-center text-center transition-colors">
                    <p className="text-[10px] text-gray-400 uppercase font-bold">Cédula / DNI</p>
                    <p className="text-sm font-bold text-gray-800 mt-1.5">{user?.codigo_institucional || '—'}</p>
                </div>
                <div className="bg-white hover:bg-gray-50 flex-1 px-4 py-4 flex flex-col justify-center text-center transition-colors">
                    <p className="text-[10px] text-gray-400 uppercase font-bold">F. Nacimiento</p>
                    <p className="text-sm font-bold text-gray-800 mt-1.5">
                        {user?.fecha_nacimiento
                            ? new Date(user.fecha_nacimiento).toLocaleDateString('es-ES', { timeZone: 'UTC' })
                            : 'No registrado'}
                    </p>
                </div>
                <div className="bg-white hover:bg-gray-50 flex-1 px-4 py-4 flex flex-col justify-center text-center transition-colors">
                    <p className="text-[10px] text-gray-400 uppercase font-bold">Ocupación</p>
                    <p className="text-sm font-bold text-gray-800 mt-1.5">{user?.ocupacion || 'No registrado'}</p>
                </div>
                <div className="bg-white hover:bg-gray-50 flex-1 px-4 py-4 flex flex-col justify-center text-center transition-colors">
                    <p className="text-[10px] text-gray-400 uppercase font-bold">Celular</p>
                    <p className="text-sm font-bold text-gray-800 mt-1.5">{user?.celular_contacto || 'No registrado'}</p>
                </div>
                <div className="col-span-2 lg:col-span-1 bg-white hover:bg-gray-50 flex-1 px-4 py-4 flex flex-col justify-center text-center transition-colors">
                    <p className="text-[10px] text-gray-400 uppercase font-bold">Residencia</p>
                    <p className="text-sm font-bold text-gray-800 mt-1.5">{user?.ciudad_residencia || 'No registrado'}</p>
                </div>
                {/* Botón Editar usuario */}
                <div className="col-span-2 lg:col-span-1 bg-white lg:w-auto px-6 py-4 flex items-center justify-center">
                    {isGlobalAdminViewer ? (
                        <button
                            type="button"
                            className="bg-white border border-gray-200 hover:bg-gray-100 hover:border-gray-300 text-gray-700 font-bold px-6 py-2.5 rounded-full transition-colors shadow-sm text-xs flex items-center justify-center gap-2 w-full lg:w-auto whitespace-nowrap"
                            onClick={handleOpenEdit}
                        >
                            ✏️ Editar usuario
                        </button>
                    ) : (
                        <button
                            disabled
                            className="bg-gray-50 border border-gray-200 text-gray-400 font-bold px-6 py-2.5 rounded-full shadow-sm text-xs flex items-center justify-center gap-2 w-full lg:w-auto cursor-not-allowed whitespace-nowrap"
                            title="Solo lectura"
                        >
                            🔒 Solo lectura
                        </button>
                    )}
                </div>
            </div>

            {/* === PESTAÑAS === */}
            <div className="flex flex-nowrap overflow-x-auto gap-3 mb-2 pb-2 w-full">
                <button
                    type="button"
                    onClick={() => setTab("estudiante")}
                    className={`font-bold px-6 py-3 rounded-full flex items-center gap-2 shadow-sm text-sm transition-all shrink-0 ${tab === "estudiante" ? 'bg-white border-2 border-green-600 text-green-700' : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50'}`}
                >
                    🎓 Gestionar Cursos
                </button>
                {isGlobalAdminViewer && (
                    <button
                        type="button"
                        onClick={() => setTab("docente")}
                        className={`font-bold px-6 py-3 rounded-full flex items-center gap-2 shadow-sm text-sm transition-all shrink-0 ${tab === "docente" ? 'bg-white border-2 border-orange-500 text-orange-700' : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50'}`}
                    >
                        👨‍🏫 Asignar Facultades y Admin
                    </button>
                )}
            </div>

            {/* === PANEL DE CONTENIDO (sin cambios de lógica) === */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
                {error && (
                    <div className="mb-4 bg-yellow-50 border border-yellow-200 rounded-xl p-3 text-yellow-800 font-medium text-sm">
                        {error}
                    </div>
                )}

                {/* Panel Estudiante */}
                {tab === "estudiante" && (
                    <div>
                        {/* Header con título y contadores */}
                        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6 pb-4 border-b border-gray-100">
                            <div>
                                <h2 className="text-lg font-black text-gray-800 flex items-center gap-2">
                                    📖 Gestionar Cursos
                                </h2>
                                <p className="text-sm text-gray-500 mt-1">
                                    Administra los cursos asignados al usuario y añade nuevas inscripciones.
                                </p>
                            </div>
                            <div className="flex gap-2 shrink-0">
                                <div className="bg-blue-50 border border-blue-100 px-3 py-1.5 rounded-xl flex flex-col items-center min-w-[75px]">
                                    <span className="text-[10px] font-bold text-blue-600 uppercase">Estudiante</span>
                                    <span className="text-lg font-black text-blue-700 leading-none mt-0.5">{inscripciones.length}</span>
                                </div>
                                <div className="bg-yellow-50 border border-yellow-100 px-3 py-1.5 rounded-xl flex flex-col items-center min-w-[75px]">
                                    <span className="text-[10px] font-bold text-yellow-600 uppercase">Docente</span>
                                    <span className="text-lg font-black text-yellow-700 leading-none mt-0.5">{asignaciones.filter(a => a.rol === 'docente').length}</span>
                                </div>
                                <div className="bg-green-50 border border-green-100 px-3 py-1.5 rounded-xl flex flex-col items-center min-w-[75px]">
                                    <span className="text-[10px] font-bold text-green-600 uppercase">Asistente</span>
                                    <span className="text-lg font-black text-green-700 leading-none mt-0.5">{asignaciones.filter(a => a.rol === 'asistente').length}</span>
                                </div>
                            </div>
                        </div>

                        {/* Formulario inscribir */}
                        <h3 className="font-bold text-gray-800 text-sm mb-3 px-1 border-b border-gray-100 pb-2">Inscribir a curso</h3>
                        <div className="flex flex-col lg:flex-row gap-3 mb-6 bg-gray-50 p-4 rounded-2xl border border-gray-100 items-stretch">
                            {/* 1. Rol */}
                            <select
                                value={selectedRolCurso}
                                onChange={e => setSelectedRolCurso(e.target.value)}
                                className="w-full lg:w-48 border border-gray-300 rounded-full px-4 py-2.5 bg-white text-sm font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500 shadow-sm shrink-0"
                            >
                                <option value="estudiante">1. Rol: Estudiante</option>
                                <option value="docente">1. Rol: Docente</option>
                                <option value="asistente">1. Rol: Asistente</option>
                            </select>

                            {/* 2. Facultad */}
                            <select
                                value={selectedFacAsignar}
                                onChange={e => { setSelectedFacAsignar(e.target.value); setSearchCursoAsignar(''); }}
                                disabled={isDocente}
                                className="flex-1 border border-gray-300 rounded-full px-4 py-2.5 bg-white text-sm font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500 shadow-sm disabled:bg-gray-100 disabled:opacity-70 disabled:cursor-not-allowed"
                            >
                                <option value="">2. Elegir Facultad...</option>
                                {allFacultades
                                    .filter(f => isDocente ? String(f.id) === String(authUserFacultadId) : true)
                                    .map(f => <option key={f.id} value={f.id}>{f.nombre}</option>) /* ✅ CORREGIDO: value={f.id} */
                                }
                            </select>

                            {/* 3. Buscar curso + Inscribir */}
                            <div className="flex flex-col sm:flex-row gap-3 flex-1">
                                <div className="relative flex-1">
                                    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-sm">🔍</span>
                                    <input
                                        list="cursos-disponibles-list"
                                        disabled={!selectedFacAsignar}
                                        type="text"
                                        value={searchCursoAsignar}
                                        onChange={e => setSearchCursoAsignar(e.target.value)}
                                        placeholder="3. Buscar o seleccionar curso..."
                                        className="w-full pl-10 pr-4 py-2.5 text-sm font-medium border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-green-500 bg-white disabled:bg-gray-100 disabled:opacity-70 shadow-sm"
                                    />
                                    <datalist id="cursos-disponibles-list">
                                        {/* ✅ CORREGIDO: Validar rol y filtrar por facultad_id */}
                                        {(selectedRolCurso === 'estudiante' ? availableCoursesForStudent : availableCoursesForTeacher)
                                            .filter(c => !selectedFacAsignar || String(c.facultad_id) === String(selectedFacAsignar))
                                            .map(c => <option key={c.id} value={c.nombre}>{c.codigo_curso || c.curso_codigo} - {c.nombre}</option>)
                                        }
                                    </datalist>
                                </div>
                                <button
                                    type="button"
                                    disabled={enrollSubmitting || !searchCursoAsignar}
                                    onClick={async () => {
                                        // ✅ CORREGIDO: Buscar en la lista correcta según el rol elegido
                                        const listaCursos = selectedRolCurso === 'estudiante' ? availableCoursesForStudent : availableCoursesForTeacher;
                                        const curso = listaCursos.find(c => c.nombre === searchCursoAsignar);

                                        if (!curso) return;
                                        setEnrollSubmitting(true);
                                        setError(null);
                                        try {
                                            if (selectedRolCurso === 'estudiante') {
                                                if (!hasRole('estudiante')) await ensureRole('estudiante');
                                                await enrollStudentToCourse(curso.id, { usuario_id: uid, curso_id: curso.id, estado: 'inscrito' });
                                                await loadStudentData();
                                            } else {
                                                await assignTeacherToCourse(curso.id, { usuario_id: uid, rol: selectedRolCurso, activo: true, tipo_asignacion: selectedRolCurso });
                                                await loadTeacherData();
                                            }
                                            setSearchCursoAsignar('');
                                            setSelectedFacAsignar('');
                                        } catch (ex) {
                                            setError(ex.message);
                                        } finally {
                                            setEnrollSubmitting(false);
                                        }
                                    }}
                                    className="bg-green-600 hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-bold px-6 py-2.5 rounded-full transition-colors shadow-sm text-sm shrink-0"
                                >
                                    {enrollSubmitting ? 'Inscribiendo…' : 'Inscribir'}
                                </button>
                            </div>
                        </div>

                        {/* Controles de vista de cursos asignados */}
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 mt-8 gap-3 px-1">
                            <h3 className="font-bold text-gray-800 text-sm">Cursos Actuales Asignados</h3>
                            <div className="flex flex-col sm:flex-row items-center gap-2 w-full sm:w-auto">
                                {/* Buscador */}
                                <div className="relative w-full sm:w-48">
                                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs">🔍</span>
                                    <input
                                        type="text"
                                        value={searchCursoAsignado}
                                        onChange={e => setSearchCursoAsignado(e.target.value)}
                                        placeholder="Filtrar curso..."
                                        className="w-full pl-8 pr-3 py-2 text-xs border border-gray-200 rounded-full focus:outline-none focus:ring-1 focus:ring-green-500 shadow-sm"
                                    />
                                </div>
                                {/* Filtro rol */}
                                <select
                                    value={cursoRolFilter}
                                    onChange={e => setCursoRolFilter(e.target.value)}
                                    className="w-full sm:w-auto border border-gray-200 shadow-sm rounded-full px-4 py-2 text-xs font-bold text-gray-600 focus:outline-none focus:ring-1 focus:ring-green-500"
                                >
                                    <option value="Todos">Rol: Todos</option>
                                    <option value="estudiante">Rol: Estudiante</option>
                                    <option value="docente">Rol: Docente</option>
                                    <option value="asistente">Rol: Asistente</option>
                                </select>
                                {/* Toggle lista/grid */}
                                <div className="flex items-center border border-gray-200 rounded-full p-1 bg-gray-50 shadow-sm shrink-0">
                                    <button
                                        onClick={() => setCursoViewMode('table')}
                                        className={`p-1.5 rounded-full transition-colors ${cursoViewMode === 'table' ? 'bg-white shadow-sm text-green-700 border border-gray-100' : 'text-gray-400 hover:text-gray-600'}`}
                                    >☰</button>
                                    <button
                                        onClick={() => setCursoViewMode('grid')}
                                        className={`p-1.5 rounded-full transition-colors ${cursoViewMode === 'grid' ? 'bg-white shadow-sm text-green-700 border border-gray-100' : 'text-gray-400 hover:text-gray-600'}`}
                                    >⊞</button>
                                </div>
                            </div>
                        </div>

                        {/* Combinar inscripciones + asignaciones para la tabla */}
                        {(() => {
                            // Unificar en un solo array para mostrar todo junto
                            const todosLosCursos = [
                                ...inscripciones
                                    .filter(i => {
                                        const matchSearch = !searchCursoAsignado || (i.curso_nombre || '').toLowerCase().includes(searchCursoAsignado.toLowerCase());
                                        const matchRol = cursoRolFilter === 'Todos' || cursoRolFilter === 'estudiante';
                                        return matchSearch && matchRol;
                                    })
                                    .map(i => ({ ...i, _tipo: 'estudiante', _displayRol: 'estudiante' })),
                                ...asignaciones
                                    .filter(a => {
                                        const matchSearch = !searchCursoAsignado || (a.curso_nombre || '').toLowerCase().includes(searchCursoAsignado.toLowerCase());
                                        const matchRol = cursoRolFilter === 'Todos' || cursoRolFilter === a.rol;
                                        return matchSearch && matchRol;
                                    })
                                    .map(a => ({ ...a, _tipo: 'docente', _displayRol: a.rol }))
                            ];

                            if (todosLosCursos.length === 0 && !studentLoading && !teacherLoading) {
                                return (
                                    <p className="text-sm text-gray-500 p-8 text-center border border-dashed border-gray-200 rounded-2xl font-medium">
                                        No se encontraron cursos asignados.
                                    </p>
                                );
                            }

                            if (cursoViewMode === 'table') {
                                return (
                                    <div className="border border-gray-200 rounded-2xl overflow-hidden bg-white shadow-sm">
                                        <div className="overflow-x-auto">
                                            <table className="w-full text-left border-collapse min-w-[760px]">
                                                <thead>
                                                    <tr className="bg-gray-50 border-b border-gray-200 text-gray-500 text-xs uppercase tracking-wider">
                                                        <th className="px-3 py-3 font-bold cursor-pointer hover:bg-gray-100 select-none" onClick={() => handleSortCurso('facultad')}>
                                                            Facultad{getCursoSortIcon('facultad')}
                                                        </th>
                                                        <th className="px-3 py-3 font-bold cursor-pointer hover:bg-gray-100 select-none" onClick={() => handleSortCurso('curso_nombre')}>
                                                            Curso{getCursoSortIcon('curso_nombre')}
                                                        </th>
                                                        <th className="px-3 py-3 font-bold cursor-pointer hover:bg-gray-100 select-none text-center" onClick={() => handleSortCurso('_displayRol')}>
                                                            Rol{getCursoSortIcon('_displayRol')}
                                                        </th>
                                                        <th className="px-3 py-3 font-bold cursor-pointer hover:bg-gray-100 select-none" onClick={() => handleSortCurso('fecha_inscripcion')}>
                                                            Detalle Inscripción{getCursoSortIcon('fecha_inscripcion')}
                                                        </th>
                                                        <th className="px-3 py-3 font-bold cursor-pointer hover:bg-gray-100 select-none" onClick={() => handleSortCurso('ultimo_acceso')}>
                                                            Últ. Acceso{getCursoSortIcon('ultimo_acceso')}
                                                        </th>
                                                        <th className="px-3 py-3 font-bold text-center">Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {todosLosCursos.map((item, idx) => {
                                                        const isEstudiante = item._tipo === 'estudiante';
                                                        const assignmentId = !isEstudiante ? getAssignmentId(item) : null;
                                                        const isToggling = togglingAssignmentId === assignmentId;
                                                        const rolStyles = {
                                                            estudiante: 'bg-blue-50 text-blue-600 border-blue-100',
                                                            docente: 'bg-yellow-50 text-yellow-600 border-yellow-200',
                                                            asistente: 'bg-green-50 text-green-600 border-green-100',
                                                        };
                                                        return (
                                                            <tr key={idx} className="border-b border-gray-100 hover:bg-gray-50/50 transition-colors">
                                                                {/* Facultad */}
                                                                <td className="px-3 py-2.5 align-middle">
                                                                    <div className="font-bold text-gray-800 text-[13px] uppercase truncate max-w-[150px]">
                                                                        {item.facultad_nombre || '—'}
                                                                    </div>
                                                                    {item.facultad_codigo && (
                                                                        <span className="text-[10px] text-gray-500 font-bold bg-gray-100 px-1.5 py-0.5 rounded border border-gray-200 mt-0.5 inline-block">
                                                                            {item.facultad_codigo}
                                                                        </span>
                                                                    )}
                                                                </td>
                                                                {/* Curso */}
                                                                <td className="px-3 py-2.5 align-middle">
                                                                    <div className="font-bold text-gray-800 text-[13px] uppercase max-w-[200px]">
                                                                        {item.curso_nombre || '—'}
                                                                    </div>
                                                                    <div className="text-[10px] text-gray-500 font-bold mt-0.5">
                                                                        Cód: {item.curso_codigo || item.codigo_curso || '—'}
                                                                    </div>
                                                                    {item.tipo && (
                                                                        <div className="text-[10px] text-gray-400 font-medium">
                                                                            Tipo: {item.tipo === 'examen_solo' ? 'Solo examen' : item.tipo === 'regular' ? 'Regular' : item.tipo}
                                                                        </div>
                                                                    )}
                                                                </td>
                                                                {/* Rol */}
                                                                <td className="px-3 py-2.5 text-center align-middle">
                                                                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-black uppercase border ${rolStyles[item._displayRol] || rolStyles.estudiante}`}>
                                                                        {item._displayRol === 'estudiante' ? 'Estudiante' : item._displayRol === 'docente' ? 'Docente' : 'Asistente'}
                                                                    </span>
                                                                </td>
                                                                {/* Detalle inscripción */}
                                                                <td className="px-3 py-2.5 text-xs text-gray-600 align-middle">
                                                                    <div className="flex flex-col gap-1">
                                                                        <span className="flex items-center gap-1.5">
                                                                            📅 {isEstudiante
                                                                                ? (item.fecha_inscripcion ? new Date(item.fecha_inscripcion).toLocaleDateString('es-ES') : '—')
                                                                                : (item.fecha_asignacion ? new Date(item.fecha_asignacion).toLocaleDateString('es-ES') : '—')
                                                                            }
                                                                        </span>
                                                                        <span className="flex items-center gap-1.5 text-[10px] font-medium text-gray-400">
                                                                            👤 {item.inscrito_por || item.asignado_por || 'sistema@utm.edu'}
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                                {/* Últ. acceso */}
                                                                <td className="px-3 py-2.5 text-xs font-semibold text-gray-700 align-middle">
                                                                    {item.ultimo_acceso || 'Nunca'}
                                                                </td>
                                                                {/* Acciones */}
                                                                <td className="px-3 py-2.5 text-center align-middle">
                                                                    <div className="flex items-center justify-center gap-1">
                                                                        <button
                                                                            type="button"
                                                                            className="text-blue-500 hover:text-blue-700 hover:bg-blue-50 p-1.5 rounded-lg transition-colors border border-transparent hover:border-blue-100"
                                                                            title="Ver Reporte"
                                                                        >📊</button>
                                                                        {isEstudiante ? (
                                                                            <button
                                                                                type="button"
                                                                                onClick={async () => {
                                                                                    if (!window.confirm('¿Remover inscripción?')) return;
                                                                                    try {
                                                                                        await removeStudentFromCourse(item.id);
                                                                                        await loadStudentData();
                                                                                    } catch (e) { setError(e.message); }
                                                                                }}
                                                                                className="text-red-500 hover:text-red-700 hover:bg-red-50 p-1.5 rounded-lg transition-colors border border-transparent hover:border-red-100"
                                                                                title="Eliminar inscripción"
                                                                            >🗑️</button>
                                                                        ) : (
                                                                            <button
                                                                                type="button"
                                                                                onClick={async () => {
                                                                                    if (!window.confirm('¿Remover asignación?')) return;
                                                                                    if (!assignmentId) return setError('No se pudo determinar el ID');
                                                                                    try {
                                                                                        await removeTeacherFromCourse(assignmentId);
                                                                                        await loadTeacherData();
                                                                                    } catch (e) { setError(e.message); }
                                                                                }}
                                                                                className="text-red-500 hover:text-red-700 hover:bg-red-50 p-1.5 rounded-lg transition-colors border border-transparent hover:border-red-100"
                                                                                title="Eliminar asignación"
                                                                            >🗑️</button>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                    {todosLosCursos.length === 0 && (
                                                        <tr><td colSpan="6" className="p-8 text-center text-sm text-gray-500 font-medium">No se encontraron cursos asignados en base a los filtros aplicados.</td></tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        {/* Paginación */}
                                        {todosLosCursos.length > 0 && (
                                            <div className="p-3 border-t border-gray-100 bg-gray-50/50 flex justify-between items-center">
                                                <div className="flex items-center gap-2 text-xs text-gray-600">
                                                    <span>Mostrar:</span>
                                                    <select
                                                        value={cursosPageSize}
                                                        onChange={e => setCursosPageSize(Number(e.target.value))}
                                                        className="border border-gray-300 rounded px-1.5 py-0.5 bg-white focus:outline-none"
                                                    >
                                                        <option>10</option>
                                                        <option>25</option>
                                                        <option>50</option>
                                                    </select>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    <button className="p-1 text-gray-400 disabled:opacity-50" disabled>‹</button>
                                                    <span className="text-xs font-bold text-gray-600">Pág 1</span>
                                                    <button className="p-1 text-gray-400 disabled:opacity-50" disabled>›</button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            }

                            // Vista GRID
                            return (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {todosLosCursos.map((item, idx) => {
                                        const isEstudiante = item._tipo === 'estudiante';
                                        const assignmentId = !isEstudiante ? getAssignmentId(item) : null;
                                        const lineColor = item._displayRol === 'docente' ? 'bg-yellow-500' : item._displayRol === 'asistente' ? 'bg-green-500' : 'bg-blue-500';
                                        const rolStyles = {
                                            estudiante: 'bg-blue-50 text-blue-600 border-blue-100',
                                            docente: 'bg-yellow-50 text-yellow-600 border-yellow-200',
                                            asistente: 'bg-green-50 text-green-600 border-green-100',
                                        };
                                        return (
                                            <div key={idx} className="border border-gray-200 rounded-2xl p-5 bg-white hover:shadow-md transition-shadow flex flex-col relative overflow-hidden group">
                                                <div className={`absolute top-0 right-0 w-1.5 h-full ${lineColor}`} />
                                                <div className="flex justify-between items-start mb-2">
                                                    <div>
                                                        <h3 className="font-bold text-gray-900 text-sm pr-6 leading-tight uppercase">{item.curso_nombre || '—'}</h3>
                                                        <p className="text-[10px] text-gray-500 mt-1 font-medium bg-gray-100 w-max px-1.5 py-0.5 rounded">{item.facultad_nombre || '—'}</p>
                                                        <p className="text-[10px] text-gray-500 font-medium border border-gray-200 w-max px-1.5 py-0.5 rounded mt-0.5">Cód: {item.curso_codigo || item.codigo_curso || '—'}</p>
                                                        {item.tipo && <p className="text-[10px] text-gray-400 font-medium mt-1">Tipo: {item.tipo === 'examen_solo' ? 'Solo examen' : 'Regular'}</p>}
                                                    </div>
                                                    <div className="flex gap-1 shrink-0">
                                                        <button type="button" className="text-blue-500 hover:text-blue-700 hover:bg-blue-50 p-1.5 rounded-lg transition-colors" title="Ver Reporte">📊</button>
                                                        <button
                                                            type="button"
                                                            onClick={async () => {
                                                                if (!window.confirm(isEstudiante ? '¿Remover inscripción?' : '¿Remover asignación?')) return;
                                                                try {
                                                                    if (isEstudiante) { await removeStudentFromCourse(item.id); await loadStudentData(); }
                                                                    else { await removeTeacherFromCourse(assignmentId); await loadTeacherData(); }
                                                                } catch (e) { setError(e.message); }
                                                            }}
                                                            className="text-red-400 hover:text-red-600 hover:bg-red-50 p-1.5 rounded-lg transition-colors"
                                                        >🗑️</button>
                                                    </div>
                                                </div>
                                                <div className="mb-4 mt-2">
                                                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-black uppercase border ${rolStyles[item._displayRol] || rolStyles.estudiante}`}>
                                                        {item._displayRol === 'estudiante' ? 'Estudiante' : item._displayRol === 'docente' ? 'Docente' : 'Asistente'}
                                                    </span>
                                                </div>
                                                <div className="mt-auto bg-gray-50 rounded-xl p-3 text-xs text-gray-600 flex flex-col gap-2 border border-gray-100">
                                                    <div className="flex justify-between items-center">
                                                        <span className="text-gray-400 font-bold">Inscripción:</span>
                                                        <span className="font-semibold">{isEstudiante ? (item.fecha_inscripcion ? new Date(item.fecha_inscripcion).toLocaleDateString('es-ES') : '—') : (item.fecha_asignacion ? new Date(item.fecha_asignacion).toLocaleDateString('es-ES') : '—')}</span>
                                                    </div>
                                                    <div className="flex justify-between items-center">
                                                        <span className="text-gray-400 font-bold">Por:</span>
                                                        <span>{item.inscrito_por || item.asignado_por || 'sistema'}</span>
                                                    </div>
                                                    <div className="flex justify-between items-center">
                                                        <span className="text-gray-400 font-bold">Últ. acceso:</span>
                                                        <span className="text-gray-800 font-semibold">{item.ultimo_acceso || 'Nunca'}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                    {todosLosCursos.length === 0 && (
                                        <div className="col-span-full p-8 text-center text-sm font-medium text-gray-500 border border-gray-200 border-dashed rounded-2xl">No se encontraron cursos asignados.</div>
                                    )}
                                </div>
                            );
                        })()}
                    </div>
                )}

                {/* ===== MODAL EDITAR USUARIO ===== */}
                {showEditModal && (
                    <div className="fixed inset-0 z-[60] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
                        <div className="bg-white rounded-2xl shadow-xl w-full max-w-2xl flex flex-col overflow-hidden max-h-[95vh]">
                            {/* Header modal */}
                            <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50">
                                <div>
                                    <h2 className="text-lg font-extrabold text-gray-800">Editar Usuario</h2>
                                    <p className="text-sm text-gray-500 mt-0.5">
                                        {user?.apellidos?.toUpperCase()} {user?.nombres?.toUpperCase()}
                                    </p>
                                </div>
                                <button
                                    type="button"
                                    onClick={() => setShowEditModal(false)}
                                    className="p-1.5 hover:bg-gray-200 rounded-full text-gray-500 transition-colors"
                                >
                                    ✕
                                </button>
                            </div>

                            {/* Body */}
                            <div className="flex-1 overflow-y-auto p-6">
                                {editError && (
                                    <div className="mb-4 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl text-sm font-medium">
                                        {editError}
                                    </div>
                                )}
                                <form id="editUserForm" onSubmit={handleEditSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-xs font-semibold text-gray-700">Nombres <span className="text-red-500">*</span></label>
                                        <input
                                            required
                                            type="text"
                                            value={editForm.nombres}
                                            onChange={e => setEditForm(p => ({ ...p, nombres: e.target.value.toUpperCase() }))}
                                            placeholder="NOMBRES COMPLETOS"
                                            className="px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500 tracking-wide"
                                        />
                                    </div>
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-xs font-semibold text-gray-700">Apellidos <span className="text-red-500">*</span></label>
                                        <input
                                            required
                                            type="text"
                                            value={editForm.apellidos}
                                            onChange={e => setEditForm(p => ({ ...p, apellidos: e.target.value.toUpperCase() }))}
                                            placeholder="APELLIDOS COMPLETOS"
                                            className="px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500 tracking-wide"
                                        />
                                    </div>
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-xs font-semibold text-gray-700">Email <span className="text-red-500">*</span></label>
                                        <input
                                            required
                                            type="email"
                                            value={editForm.email}
                                            onChange={e => setEditForm(p => ({ ...p, email: e.target.value }))}
                                            placeholder="correo@ejemplo.com"
                                            className="px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                                        />
                                    </div>
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-xs font-semibold text-gray-700">Cédula / código institucional</label>
                                        <input
                                            type="text"
                                            value={editForm.codigo_institucional}
                                            onChange={e => setEditForm(p => ({ ...p, codigo_institucional: e.target.value }))}
                                            placeholder="CÉDULA"
                                            maxLength={20}
                                            className="px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500 tracking-wide"
                                        />
                                    </div>
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-xs font-semibold text-gray-700">Fecha de nacimiento</label>
                                        <input
                                            type="date"
                                            value={editForm.fecha_nacimiento}
                                            onChange={e => setEditForm(p => ({ ...p, fecha_nacimiento: e.target.value }))}
                                            className="px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500 text-gray-700"
                                        />
                                    </div>
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-xs font-semibold text-gray-700">Ocupación</label>
                                        <input
                                            type="text"
                                            value={editForm.ocupacion}
                                            onChange={e => setEditForm(p => ({ ...p, ocupacion: e.target.value }))}
                                            placeholder="Ej. Estudiante..."
                                            className="px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                                        />
                                    </div>
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-xs font-semibold text-gray-700">Celular de contacto</label>
                                        <input
                                            type="tel"
                                            value={editForm.celular_contacto}
                                            onChange={e => setEditForm(p => ({ ...p, celular_contacto: e.target.value }))}
                                            placeholder="Ej. 0991234567"
                                            className="px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                                        />
                                    </div>
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-xs font-semibold text-gray-700">Ciudad de residencia</label>
                                        <input
                                            type="text"
                                            value={editForm.ciudad_residencia}
                                            onChange={e => setEditForm(p => ({ ...p, ciudad_residencia: e.target.value }))}
                                            placeholder="Ej. Portoviejo"
                                            className="px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                                        />
                                    </div>
                                </form>
                            </div>

                            {/* Footer modal */}
                            <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-end gap-3">
                                <button
                                    type="button"
                                    onClick={() => setShowEditModal(false)}
                                    className="px-5 py-2.5 text-sm rounded-full font-semibold text-gray-600 bg-white border border-gray-300 hover:bg-gray-50 transition-colors"
                                    disabled={editSubmitting}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    form="editUserForm"
                                    disabled={editSubmitting}
                                    className="px-6 py-2.5 text-sm rounded-full font-bold text-white bg-[#2d8f4e] hover:bg-[#23703c] disabled:opacity-60 shadow-sm transition-colors"
                                >
                                    {editSubmitting ? 'Guardando…' : 'Guardar Cambios'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {/* Panel Docente / Asistente */}
                {tab === "docente" && isGlobalAdminViewer && (
                    <div>
                        {/* === ALCANCE ADMINISTRATIVO DE FACULTAD === */}
                        <div className="mb-8">
                            <h2 className="text-lg font-black text-gray-800 flex items-center gap-2 mb-1">
                                <span className="text-orange-600">🏛️</span> Alcance Administrativo de Facultad
                            </h2>
                            <p className="text-sm text-gray-500 mt-1">Asigna facultades específicas para que este usuario pueda administrar su información.</p>
                        </div>

                        {/* Formulario asignar facultad */}
                        <div className="flex flex-col md:flex-row gap-3 mb-6 bg-gray-50 p-4 rounded-2xl border border-gray-100">
                            <select
                                value={selectedFacAdmin}
                                onChange={e => setSelectedFacAdmin(e.target.value)}
                                className="flex-1 md:max-w-md border border-gray-300 rounded-full px-4 py-2.5 bg-white text-sm font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-500 shadow-sm"
                            >
                                <option value="">Seleccionar facultad...</option>
                                {allFacultades.map(f => (
                                    <option key={f.id} value={f.id}>{f.nombre}</option>
                                ))}
                            </select>
                            <button
                                type="button"
                                disabled={!selectedFacAdmin || assignSubmitting}
                                onClick={async () => {
    if (!selectedFacAdmin) return;
    setAssignSubmitting(true);
    setError(null);
    try {
        const yaAsignada = (user?.facultades || []).some(
            f => String(f.id || f.facultad_id) === String(selectedFacAdmin)
        );
        if (yaAsignada) {
            setError('Este usuario ya tiene acceso a esa facultad.');
            return;
        }
        await addFacultyAdmin(selectedFacAdmin, {
            usuario_id: user.id,
            rol: 'admin',
            activo: true,
        });
        // ✅ Recargar el usuario completo, no solo los cursos
        setSelectedFacAdmin('');
        await loadUser();
    } catch (ex) {
        setError(ex.message);
    } finally {
        setAssignSubmitting(false);
    }
}}
                                className="bg-orange-500 hover:bg-orange-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-bold px-6 py-2.5 rounded-full transition-colors shadow-sm text-sm shrink-0"
                            >
                                Otorgar acceso
                            </button>
                        </div>

                        {/* Lista de facultades asignadas */}
                        <div className="space-y-3 mb-10">
                            {(user?.facultades || []).length === 0 ? (
                                <p className="text-sm text-gray-500 p-6 border border-dashed border-gray-200 rounded-2xl text-center font-medium">
                                    No tiene asignada ninguna facultad.
                                </p>
                            ) : (
                                (user?.facultades || []).map((fac, idx) => (
                                    <div key={idx} className="border border-gray-200 rounded-2xl p-4 flex flex-col md:flex-row md:justify-between md:items-center bg-white hover:border-orange-200 transition-colors gap-3 shadow-sm">
                                        <div className="flex items-center gap-4">
                                            <div className="w-11 h-11 rounded-full bg-orange-50 border border-orange-100 flex items-center justify-center text-orange-600 shrink-0 text-lg">🏛️</div>
                                            <div>
                                                <h3 className="font-bold text-gray-900 text-sm">{fac.nombre || fac.facultad_nombre || fac}</h3>
                                                <div className="text-[11px] text-gray-500 mt-1 flex items-center gap-3 font-medium">
                                                    <span className="flex items-center gap-1.5">📅 {fac.fecha_asignacion ? new Date(fac.fecha_asignacion).toLocaleDateString('es-ES') : '—'}</span>
                                                    <span className="flex items-center gap-1.5">👤 {fac.asignado_por || 'sistema@utm.edu'}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={async () => {
                                                if (!window.confirm('¿Quitar acceso a esta facultad?')) return;
                                                await removeFacultyAdmin(fac.id || fac.facultad_id);
                                                await loadTeacherData();
                                            }}
                                            className="text-red-500 hover:text-red-700 hover:bg-red-50 border border-transparent hover:border-red-100 p-2.5 rounded-xl transition-colors self-end md:self-auto"
                                        >🗑️</button>
                                    </div>
                                ))
                            )}
                        </div>

                        {/* === PERMISOS DE ADMINISTRADOR GLOBAL === */}
                        <div className="pt-8 border-t border-gray-200">
                            <h2 className="text-lg font-black text-gray-800 flex items-center gap-2 mb-2">
                                <span className={hasRole('administrador') ? 'text-green-600' : 'text-gray-400'}>🛡️</span> Permisos de Administrador Global
                            </h2>
                            <p className="text-sm text-gray-500 mb-6 font-medium">
                                El administrador global tiene acceso irrestricto a todas las facultades, cursos y configuraciones del sistema.
                            </p>

                            {(() => {
                                const isAdmin = hasRole('administrador');
                                return (
                                    <div className={`p-6 rounded-2xl border flex flex-col md:flex-row items-center justify-between gap-5 shadow-sm transition-colors ${isAdmin ? 'bg-green-50 border-green-200' : 'bg-gray-50 border-gray-200'}`}>
                                        <div>
                                            <h4 className={`font-extrabold text-sm ${isAdmin ? 'text-green-800' : 'text-gray-700'}`}>
                                                {isAdmin ? 'Estado: Administrador Global Activo' : 'Estado: Sin permisos globales'}
                                            </h4>
                                            <p className={`text-xs mt-1.5 font-medium ${isAdmin ? 'text-green-700' : 'text-gray-500'}`}>
                                                {isAdmin ? 'Este usuario puede modificar cualquier registro en el sistema.' : 'Para otorgar control total, asígnale el rol de administrador.'}
                                            </p>
                                        </div>
                                        <button
                                            type="button"
                                            disabled={adminSubmitting}
                                            onClick={toggleAdminRole}
                                            className={`px-6 py-3 rounded-full font-bold text-sm shadow-sm transition-colors whitespace-nowrap text-white disabled:opacity-60 ${isAdmin ? 'bg-red-500 hover:bg-red-600' : 'bg-green-600 hover:bg-green-700'}`}
                                        >
                                            {adminSubmitting ? '…' : isAdmin ? 'Quitar Admin Global' : 'Asignar Admin Global'}
                                        </button>
                                    </div>
                                );
                            })()}
                        </div>
                    </div>
                )}
            </div>

        </div>
    );
};

export default AdminUsuarioDetalle;